import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { RequestProcessPrescriptionStateInput } from './RequestProcessPrescriptionStateInput';
import { RequestProcessPrescriptionStateOutput } from './RequestProcessPrescriptionStateOutput';

export class RequestProcessPrescriptionStateService extends HttpServiceBase {

  handle = (input: RequestProcessPrescriptionStateInput): Promise<Result<RequestProcessPrescriptionStateOutput> | null> => {
    const promise = this.http.post<Result<RequestProcessPrescriptionStateOutput>, RequestProcessPrescriptionStateInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/prescription-state-processing-request`,
      input
    );
    return promise;
  }
}